// ------- Minus-Icon ------- //
export const MinusIcon = ({ color = "currentcolor", size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3346_109443)">
      <path
        d="M0.586642 8.11918C0.610599 8.23956 0.669703 8.35013 0.756481 8.43692L1.1956 8.61889L14.8045 8.61889C14.9692 8.61889 15.1271 8.55348 15.2435 8.43706C15.3599 8.32064 15.4253 8.16274 15.4253 7.99809C15.4253 7.83344 15.3599 7.67554 15.2435 7.55912C15.1271 7.4427 14.9692 7.37729 14.8045 7.37729L1.19551 7.37729C1.19551 7.37729 1.1955 7.37729 1.1955 7.37729C1.07272 7.37728 0.952691 7.41368 0.850598 7.48189C0.748503 7.5501 0.66893 7.64706 0.621945 7.7605C0.574961 7.87394 0.562675 7.99876 0.586642 8.11918ZM0.756536 8.43697C0.814127 8.4947 0.882553 8.54049 0.957887 8.57171C1.03321 8.60293 1.11396 8.61896 1.1955 8.61889L0.756536 8.43697Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_3346_109443">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- Plus-Icon ------- //
export const PlusIcon = ({ color = "currentcolor", size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3346_109446)">
      <path
        d="M8.11621 15.0886C8.23214 15.0655 8.33863 15.0085 8.42221 14.9249L8.35148 14.8542C8.39776 14.8081 8.43447 14.7532 8.45949 14.6929C8.48451 14.6325 8.49736 14.5677 8.49729 14.5024H8.59729V14.5023V1.49767C8.59729 1.33916 8.53432 1.18714 8.42224 1.07505C8.31015 0.962968 8.15813 0.9 7.99962 0.9C7.84111 0.9 7.68909 0.962968 7.57701 1.07505C7.46492 1.18714 7.40195 1.33916 7.40195 1.49767L7.40195 14.5024C7.40194 14.6206 7.43698 14.7361 7.50265 14.8344H7.50265C7.56832 14.9327 7.66166 15.0093 7.77088 15.0546C7.88009 15.0998 8.00027 15.1116 8.11621 15.0886Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
      <path
        d="M14.9249 8.42416C14.8695 8.47971 14.8036 8.52378 14.7311 8.55383C14.6586 8.58388 14.5809 8.59931 14.5024 8.59925C14.5023 8.59925 14.5023 8.59924 14.5023 8.59924M14.9249 8.42416L14.5024 8.49925M14.9249 8.42416C15.0085 8.34059 15.0655 8.2341 15.0886 8.11816C15.1116 8.00222 15.0998 7.88205 15.0546 7.77283C15.0093 7.66362 14.9327 7.57027 14.8344 7.5046V7.5046C14.7361 7.43893 14.6206 7.40389 14.5024 7.40391L1.49767 7.40391C1.33916 7.40391 1.18714 7.46687 1.07505 7.57896C0.962969 7.69104 0.9 7.84306 0.9 8.00158C0.9 8.16009 0.962969 8.31211 1.07505 8.42419C1.18714 8.53628 1.33916 8.59925 1.49767 8.59925L14.5023 8.59924M14.9249 8.42416L14.8542 8.35343M14.9249 8.42416C14.925 8.42412 14.925 8.42409 14.925 8.42405L14.8542 8.35343M14.9249 8.42416L14.5023 8.59924M14.5023 8.59924L14.5024 8.49925M14.5024 8.49925C14.5677 8.49931 14.6325 8.48647 14.6929 8.46144C14.7532 8.43642 14.8081 8.39972 14.8542 8.35343M14.5024 8.49925L14.9905 8.09864C14.9713 8.19518 14.9239 8.28385 14.8542 8.35343"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </g>
    <defs>
      <clipPath id="clip0_3346_109446">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- Trash-Icon ------- //
export const TrashIcon = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3346_109455)">
        <path
          d="M13.9997 2.66667H11.933C11.7783 1.91428 11.3689 1.23823 10.7738 0.752479C10.1788 0.266727 9.43448 0.000969683 8.66634 0L7.33301 0C6.56487 0.000969683 5.82055 0.266727 5.22551 0.752479C4.63046 1.23823 4.22107 1.91428 4.06634 2.66667H1.99967C1.82286 2.66667 1.65329 2.7369 1.52827 2.86193C1.40325 2.98695 1.33301 3.15652 1.33301 3.33333C1.33301 3.51014 1.40325 3.67971 1.52827 3.80474C1.65329 3.92976 1.82286 4 1.99967 4H2.66634V12.6667C2.6674 13.5504 3.01893 14.3976 3.64382 15.0225C4.26871 15.6474 5.11594 15.9989 5.99967 16H9.99967C10.8834 15.9989 11.7306 15.6474 12.3555 15.0225C12.9804 14.3976 13.3319 13.5504 13.333 12.6667V4H13.9997C14.1765 4 14.3461 3.92976 14.4711 3.80474C14.5961 3.67971 14.6663 3.51014 14.6663 3.33333C14.6663 3.15652 14.5961 2.98695 14.4711 2.86193C14.3461 2.7369 14.1765 2.66667 13.9997 2.66667ZM7.33301 1.33333H8.66634C9.07986 1.33384 9.48309 1.46225 9.82075 1.70096C10.1584 1.93967 10.414 2.27699 10.5523 2.66667H5.44701C5.5854 2.27699 5.84094 1.93967 6.1786 1.70096C6.51626 1.46225 6.91949 1.33384 7.33301 1.33333ZM11.9997 12.6667C11.9997 13.1971 11.789 13.7058 11.4139 14.0809C11.0388 14.456 10.5301 14.6667 9.99967 14.6667H5.99967C5.46924 14.6667 4.96053 14.456 4.58546 14.0809C4.21039 13.7058 3.99967 13.1971 3.99967 12.6667V4H11.9997V12.6667Z"
          fill="#3C3C3C"
        />
        <path
          d="M6.66667 12.0013C6.84348 12.0013 7.01305 11.9311 7.13807 11.806C7.2631 11.681 7.33333 11.5114 7.33333 11.3346V7.33464C7.33333 7.15782 7.2631 6.98826 7.13807 6.86323C7.01305 6.73821 6.84348 6.66797 6.66667 6.66797C6.48986 6.66797 6.32029 6.73821 6.19526 6.86323C6.07024 6.98826 6 7.15782 6 7.33464V11.3346C6 11.5114 6.07024 11.681 6.19526 11.806C6.32029 11.9311 6.48986 12.0013 6.66667 12.0013ZM9.33333 12.0013C9.51014 12.0013 9.67971 11.9311 9.80474 11.806C9.92976 11.681 10 11.5114 10 11.3346V7.33464C10 7.15782 9.92976 6.98826 9.80474 6.86323C9.67971 6.73821 9.51014 6.66797 9.33333 6.66797C9.15652 6.66797 8.98695 6.73821 8.86193 6.86323C8.7369 6.98826 8.66667 7.15782 8.66667 7.33464V11.3346C8.66667 11.5114 8.7369 11.681 8.86193 11.806C8.98695 11.9311 9.15652 12.0013 9.33333 12.0013Z"
          fill="#3C3C3C"
        />
      </g>
      <defs>
        <clipPath id="clip0_3346_109455">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HeartIcon = ({ stroke, fill }) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.43087 2.65246L8 3.31557L8.56913 2.65246C9.3039 1.79634 10.4347 1.25 11.6 1.25C13.6507 1.25 15.25 2.84311 15.25 4.9C15.25 6.16143 14.6878 7.36839 13.5443 8.76735C12.3926 10.1764 10.7309 11.687 8.65619 13.5684L8.65511 13.5694L8 14.1658L7.34489 13.5694L7.34381 13.5684C5.26906 11.687 3.60742 10.1764 2.4557 8.76735C1.31222 7.36839 0.75 6.16143 0.75 4.9C0.75 2.84311 2.34932 1.25 4.4 1.25C5.56527 1.25 6.69609 1.79634 7.43087 2.65246Z"
        stroke={stroke}
        fill={fill}
        strokeWidth="1.5"
      />
    </svg>
  );
};
